module.exports = __webpack_public_path__ + "assets/img/healthcareSolutions-scenarios1.311c33ef.png";